// extracted by mini-css-extract-plugin
export var productImage = "_n7-0";